import { render } from "./MainViewCard.vue?vue&type=template&id=01cf2adb&ts=true"
import script from "./MainViewCard.vue?vue&type=script&lang=ts"
export * from "./MainViewCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__